import { parseParams } from '@wix/music-shared/dist/src/utils/url';

export function getLocale(): string {
  const lang = parseParams().lang;
  const mainLang = lang ? lang.split('-')[0] : undefined;
  if (mainLang && availableLanguages.includes(mainLang)) {
    return mainLang;
  }

  const locale = window.Wix.Utils.getLocale();

  return /^\w{2}$/.test(locale) ? locale : 'en';
}

const availableLanguages = [
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fi',
  'fr',
  'hi',
  'it',
  'ja',
  'ko',
  'nl',
  'no',
  'pl',
  'pt',
  'ru',
  'sv',
  'th',
  'tr',
  'uk',
  'zh',
  'zu',
];
